import {
  ChangeDetectorRef,
  Component,
  Injector,
  OnInit,
  ViewChild,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { SecondPageIndexBase } from 'vnpost-shared';
import { CreateCommissionForStageComponent } from './create-commission-for-stage/create-commission-for-stage.component';
import { EditCommissionForStageComponent } from './edit-commission-for-stage/edit-commission-for-stage.component';
import { CommissionStageService } from '../services/commission-stage.service';

@Component({
  selector: 'app-commission-for-stage',
  templateUrl: './commission-for-stage.component.html',
  styleUrls: ['./commission-for-stage.component.scss']
})
export class CommissionForStageComponent extends SecondPageIndexBase implements OnInit {
  @ViewChild('pCreate', { static: false }) pCreate: CreateCommissionForStageComponent;
  @ViewChild('pEdit', { static: false }) pEdit: EditCommissionForStageComponent;
  code: any;
  setWidth: string = '100%';
  formGroup: UntypedFormGroup;
  constructor(
    private router: Router,
    private _service: CommissionStageService,
    private cd: ChangeDetectorRef,
    protected _injector: Injector
  ) {
    super(_service, _injector);
    this.formGroup = new UntypedFormGroup({
      code: new UntypedFormControl(''),
    });
    this.cols = [
      {
        field: 'stt',
        header: 'STT',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'stageCode',
        header: 'Mã công đoạn',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'stageName',
        header: 'Tên công đoạn',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'commission_rate',
        header: 'Tỷ lệ hoa hồng(%)',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'notes',
        header: 'Ghi chú',
        visible: true,
        sort: false,
        width: 10,
      },
      {
        field: 'status',
        header: 'Trạng thái áp dụng',
        visible: true,
        sort: false,
        width: 15,
      },
      {
        field: 'action',
        header: 'Hành động',
        visible: true,
        sort: false,
        width: 15,
      },
    ];
  }
  ngOnInit(): void {
    this.getData();
  }

  search() {
    this.pageIndex = 1;
    this.pageSize = 20;
    this.totalRecord = 0;
    this.getData();
  }

  getData() {
    this.isLoading = true;
    this.code = this.code ? this.code.trim() : '';
    var model = {
      code: this.code ?? '',
      pageNo: this.pageIndex - 1,
      pageSize: this.pageSize
    };
    var index= model.pageNo*model.pageSize
    this._service
      .getListCommissionStage(model)
      .then((res) => {
        if (res) {
          
          this.dataSource = res.data;
          if(this.dataSource){
            this.dataSource.forEach(e => {
              index++
              e.stt=index
            });
          }
          this.totalRecord = res.total;
        }
      })
      .finally(() => (this.isLoading = false));
  }

  editCommissionStage(item: any, isDisable: boolean) {
    if (item && item.id)
      var model = {
        id: item.id,
        isDisable: isDisable,
      };
     this.pEdit.showPopup(model);
  }
  deleteCommissionStage(item: any) {
    if (item && item.id && item.status) {
      this._notifierService
        .showConfirm('Bạn có chắc muốn ngừng hoạt động hoa hồng theo công đoạn này')
        .then((res) => {
          if (res) {
            // this._service.delete(item.identifier).then(
            //   () => {
            //     this._notifierService.showDeleteDataSuccess();
            //     this.getData();
            //   },
            //   () => {
            //     this._notifierService.showDeleteDataError();
            //   }
            // );
            this._service.inactive(item.id).then(
              (response) => {
                this._notifierService.showUpdateDataSuccess();
                this.getData();
              },
              (error) => {
                this._notifierService.showUpdateDataFailed();
              }
            );
          }
        });
    }
  }
  onAdd() {
     this.pCreate.showPopup();
  }

  onSelectedVisible() {
    var dataWidth = 0;
    this.cols.forEach((e) => {
      if (e.visible == true) {
        dataWidth += e.width;
      }
    });
    this.setWidth = dataWidth + 'rem';
  }
}
